// src/components/BookingPage/AppointmentTypeSelection.js

import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function AppointmentTypeSelection({
  appointmentTypes,
  selectedAppointmentType,
  setSelectedAppointmentType,
  selectedEmployee,
}) {
  return (
    <FormControl fullWidth>
      <InputLabel>Terminart</InputLabel>
      <Select
        value={selectedAppointmentType}
        label="Terminart"
        onChange={(e) => setSelectedAppointmentType(e.target.value)}
      >
        {appointmentTypes.map(t => {
          // Nur aktiv, wenn Terminart den ausgewählten Mitarbeiter unterstützt
          const disabled = selectedEmployee
            ? !t.assignedEmployees.includes(selectedEmployee)
            : false;

          return (
            <MenuItem
              key={t.id}
              value={t.id}
              disabled={disabled}
              style={disabled ? { opacity: 0.5 } : {}}
            >
              {t.name} ({t.duration} Min)
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
